import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class Carregado  {
    constructor() { }
    onLoadGet  = new EventEmitter<boolean>();
    onLoadPost = new EventEmitter<boolean>();

    tarefas = 0;
    tarefasP = 0;
    finalizado: boolean;
    finalizadoPost: boolean;

    add (url) {
      // console.log(url);
        this.tarefas ++;
        this.verificaFim();
    }

    close() {
        this.tarefas --;
        this.verificaFim();
    }

    /*addPost () {
        this.tarefasP ++;
        this.verificaFim();
    }

    closePost() {
        this.tarefasP --;
        this.verificaFim();
    }*/

    verificaFim() {
        this.finalizado = this.tarefas === 0;
        // console.log(!this.finalizado);
        // console.log(this.tarefas);
        this.onLoadGet.emit(!this.finalizado);
    }

    /*verificaFimPost() {
        this.finalizadoPost = this.tarefasP === 0;
        this.onLoadPost.emit(!this.finalizadoPost);
    }*/
}



// WEBPACK FOOTER //
// ./src/app/core/carregado.ts